if (!customElements.get('sr-shop-look')) {
  customElements.define('sr-shop-look', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-look-add]');
      this.error = this.querySelector('[data-look-error]');
      this.selects = [...this.querySelectorAll('[data-look-variant]')];
      this.currency = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' });
      this.update = () => {
        let total = 0;
        let available = this.selects.length === 3;
        for (const select of this.selects) {
          const option = select.selectedOptions[0];
          if (!option) { available = false; continue; }
          available = available && !option.disabled;
          total += Number(option.dataset.price);
          this.querySelector(`[data-look-price="${select.dataset.index}"]`).textContent = this.currency.format(Number(option.dataset.price) / 100);
          const link = this.querySelector(`[data-look-image-link="${select.dataset.index}"]`);
          link.href = option.dataset.url;
          const img = link.querySelector('img');
          if (img && option.dataset.image && img.getAttribute('src') !== option.dataset.image) {
            img.removeAttribute('srcset');
            img.src = option.dataset.image;
            img.alt = option.dataset.alt;
          }
        }
        this.querySelector('[data-look-total]').textContent = this.currency.format(total / 100);
        this.button.disabled = !available;
      };
      this.addEventListener('change', this.update);
      this.button.addEventListener('click', event => this.addLook(event));
      this.update();
    }
    async addLook(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.adding;
      this.error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      const items = this.selects.map(select => ({ id: Number(select.value), quantity: 1, properties: { _sr_look: this.dataset.title } }));
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Bundle-Request': 'true' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        window.location.assign(`${root}cart`);
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.button.textContent = this.dataset.add;
        this.update();
      }
    }
  });
}
